
/*
 * HYBRID ATHLETICS
 * Shrine Bundle & Save -> Easify Product Options
 * Version 4 - Custom Dropdown Integration
 *
 * TEST ON A DUPLICATE THEME FIRST.
 */

(function () {
  'use strict';

  const BUNDLE_SELECTOR =
    '.quantity-breaks-container input[type="radio"][name="quantity"]';

  const DROPDOWN_BUTTON = '.po-select-button';
  const DROPDOWN_ITEM = '.po-select-listItem';

  let syncing = false;

  function findEasifyDropdown() {
    const buttons = Array.from(
      document.querySelectorAll(DROPDOWN_BUTTON)
    );

    return buttons.find(button => {
      const container = button.closest('.po-option-root');

      return container &&
        /number of holders/i.test(
          container.textContent || ''
        );
    }) || null;
  }

  function findQuantityOption(quantity) {
    const options = Array.from(
      document.querySelectorAll(DROPDOWN_ITEM)
    );

    return options.find(option => {
      const label =
        option.querySelector('.po-optionItemLabel') ||
        option.querySelector('label') ||
        option;

      return label.textContent.trim() === quantity;
    }) || null;
  }

  function getSelectedBundleQuantity() {
    const selected = document.querySelector(
      BUNDLE_SELECTOR + ':checked'
    );

    return selected ? selected.value.trim() : null;
  }

  function getEasifyQuantity(button) {
    const selected = button.querySelector(
      '.po-select-selectedValue'
    );

    return selected
      ? selected.textContent.trim()
      : null;
  }

  function syncQuantity() {
    if (syncing) return;

    const quantity = getSelectedBundleQuantity();
    const button = findEasifyDropdown();

    if (!quantity || !button) return;

    if (getEasifyQuantity(button) === quantity) {
      return;
    }

    syncing = true;

    // Open Easify's custom dropdown.
    button.click();

    // Wait briefly for Easify to render its options.
    setTimeout(function () {
      const option = findQuantityOption(quantity);

      if (!option) {
        console.warn(
          'HA Sync: Could not find Easify option:',
          quantity
        );

        syncing = false;
        return;
      }

      // Click the actual label rather than only the list item.
      const clickableLabel =
        option.querySelector('label') ||
        option.querySelector('.po-optionItemLabel') ||
        option;

      clickableLabel.click();

      console.log(
        'HA Sync: Attempted to select',
        quantity,
        'holders'
      );

      syncing = false;
    }, 300);
  }

  // Respond when a customer changes Bundle & Save.
  document.addEventListener('change', function (event) {
    if (event.target.matches(BUNDLE_SELECTOR)) {
      syncQuantity();
    }
  });

  // Easify may render after Shrine.
  let attempts = 0;

  const startup = setInterval(function () {
    attempts++;

    if (findEasifyDropdown()) {
      clearInterval(startup);
      syncQuantity();
    }

    if (attempts >= 40) {
      clearInterval(startup);

      console.warn(
        'HA Sync: Easify dropdown not found during startup.'
      );
    }
  }, 500);

  // Reinitialise after Shopify theme-editor section reloads.
  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(syncQuantity, 500);
    }
  );

  
  // Hide only the Easify Number of holders option.
  function hideEasifyQuantity() {
    const button = findEasifyDropdown();

    if (!button) return;

    const container = button.closest('.po-option-root');

    if (container) {
      container.classList.add(
        'ha-hidden-easify-quantity'
      );
    }
  }

  // Wait for Easify to finish loading.
  let hideAttempts = 0;

  const hideTimer = setInterval(function () {
    hideAttempts++;

    if (findEasifyDropdown()) {
      hideEasifyQuantity();
      clearInterval(hideTimer);
    }

    if (hideAttempts >= 40) {
      clearInterval(hideTimer);
    }
  }, 500);

  console.log('Hybrid Athletics Sync V4 Loaded');
})();
